import { Card, CompartmentCard } from "@/src/components/cards";
import {
  closeDrawer,
  openConfirmDialog,
  openDrawer,
} from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import { Consultation, Patient, Reference } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import { ReferenceChoiceList } from "../admin/referentiel/referenceChoiceList";
import { FieldAnswersList } from "../fields/fieldsAnswersList";
import { ReferenceFieldsForm } from "../fields/referenceFieldsForm";
import { useState } from "react";

export default function ConsultationClinicalExamCard({
  currentConsultation,
  patient,
  onChange,
}: {
  currentConsultation: Consultation;
  patient: Patient;
  onChange: (item: Consultation) => void;
}) {
  const [item, setItem] = useState(currentConsultation);
  let clinicalExam = item?.clinicalExam;
  if (!getItemId(clinicalExam) || !clinicalExam)
    return (
      <CompartmentCard
        title="Examen clinique"
        onClick={async () => {
          await openClinicalExamDrawer({
            item,
            patient,
            onChange: (newItem) => {
              setItem(newItem);
              onChange(newItem);
            },
          });
        }}
      >
        <div
          className="card redish tcenter"
          onClick={async () => {
            await openClinicalExamDrawer({
              item,
              patient,
              onChange: (newItem) => {
                setItem(newItem);
                onChange(newItem);
              },
            });
          }}
        >
          <div className="bold">Examen clinique</div>
          <div>Aucune donnée saisie</div>
        </div>
      </CompartmentCard>
    );

  return (
    <CompartmentCard
      title="Examen clinique"
      onClick={async () => {
        await openClinicalExamDrawer({
          item,
          patient,
          onChange: (newItem) => {
            setItem(newItem);
            onChange(newItem);
          },
        });
      }}
    >
      <Card
        color={"blue"}
        title={""}
        className="empty"
        onClick={async () => {
          await openClinicalExamDrawer({
            item,
            patient,
            onChange: (newItem) => {
              setItem(newItem);
              onChange(newItem);
            },
          });
        }}
        onDelete={
          getUserId() == getItemId(clinicalExam?.creator) &&
          isToday(clinicalExam._date)
            ? async () => {
                await openConfirmDialog({
                  content: "Voulez-vous vraiment supprimer cet élément ?",
                  onConfirm: async () => {
                    clinicalExam = getItemId("refAnswers:none");
                    setItem({ ...item, clinicalExam: null });
                    onChange?.(item);
                  },
                });
              }
            : undefined
        }
      >
        <div className="c1 gap10">
       
          <div className="c1 gap10">
            {clinicalExam.fieldAnswers?.length != 0 && (
              <FieldAnswersList
                patient={patient}
                reference={clinicalExam.reference}
                answers={clinicalExam.fieldAnswers}
              ></FieldAnswersList>
            )}
            {clinicalExam.notes != null && <div>{clinicalExam.notes || ""}</div>}
            {clinicalExam.conclusion != null && (
              <div className="bold">{clinicalExam.conclusion || ""}</div>
            )}
          </div>
        </div>
      </Card>
    </CompartmentCard>
  );
}

async function openClinicalExamDrawer({
  item,
  patient,
  onChange,
}: {
  item: Consultation;
  patient: Patient;
  onChange: (item: Consultation) => void;
}) {
  let clinicalExam = item?.clinicalExam;

  let speciality = USER.get()?.speciality;
  let references = speciality?.initialExaminationFormulaires || [];
  let reference: Reference | null | undefined = null;

  if (references.length == 1) reference = references[0];

  if (references.length > 1) {
    await openDrawer({
      id: "referenceChoiceDrawer",
      title: "Choisir un formulaire",
      content: (
        <ReferenceChoiceList
          current={[]}
          allReferences={references}
          categories={[]}
          onSelect={(newReference) => {
            closeDrawer("referenceChoiceDrawer");
            reference = newReference;
          }}
        />
      ),
    });
  }

  clinicalExam ||= {
    creator: getUserId(),
    reference: getItemId(reference),
    fieldAnswers: [],
    patient: getItemId(patient),
  };

  await openDrawer({
    id: "clinicalExamDrawer",
    title: reference?.name || "Examen clinique",
    additionalClasses: ["medium"],
    content: (
      <div className="c1 gap10">
        {reference != null && (
          <ReferenceFieldsForm
            patient={patient}
            currentAnswers={clinicalExam?.fieldAnswers || []}
            reference={reference}
            onChange={(newValue) => {
              clinicalExam!.fieldAnswers = newValue;
            }}
          ></ReferenceFieldsForm>
        )}

        <Input
          name="Observation"
          value={clinicalExam.notes}
          type="htmlarea"
          rows={10}
          placeholder="Champs de texte libre..."
          onChange={(newValue) => {
            clinicalExam!.notes = newValue || "";
          }}
        />
        <Input
          name="Conclusion"
          value={clinicalExam.conclusion}
          type="htmlarea"
          rows={4}
          placeholder="Champs de texte libre..."
          onChange={(newValue) => {
            clinicalExam!.conclusion = newValue || "";
          }}
        />
      </div>
    ),
    onConfirm: async () => {
      clinicalExam = await apiFetch("refAnswers", "addOne", {
        refAnswer: clinicalExam!,
      });
      item.clinicalExam = clinicalExam;
      onChange({ ...item });
      closeDrawer("historyElementDrawer");
    },
  });
}
